import api from "./api";

const healingService = {
	getHealingEvents: async (params = {}) => {
		const response = await api.get("/healing/events", { params });
		return response.data;
	},

	getHealingStats: async (workspaceId) => {
		const response = await api.get("/healing/stats", {
			params: { workspaceId },
		});
		return response.data;
	},

	applyHealing: async (eventId) => {
		const response = await api.post(`/healing/events/${eventId}/apply`);
		return response.data;
	},

	rejectHealing: async (eventId) => {
		const response = await api.post(`/healing/events/${eventId}/reject`);
		return response.data;
	},

	// Trigger on-demand AI analysis for a specific healing event.
	// Returns the updated HealingEvent with aiExplanation, aiConfidence,
	// aiSuggestedLocatorType, and aiSuggestedLocatorValue populated.
	analyzeHealing: async (eventId) => {
		const response = await api.post(`/healing/events/${eventId}/analyze`);
		return response.data;
	},

	// Ask AI for a root cause analysis of a test failure.
	// Params: { testId, failedStep, errorMessage, selector }
	analyzeFailure: async (params) => {
		const response = await api.post("/healing/analyze-failure", params);
		return response.data;
	},

	getAnalytics: async (workspaceId) => {
		const response = await api.get("/analytics/healing", {
			params: { workspaceId },
		});
		return response.data;
	},
};

export default healingService;
